module.exports = __webpack_public_path__ + "img/summary-treatment-modal-desktop.c74d0929.jpg";